import React from "react";
import {withNamespaces} from "react-i18next";
import {Button, ButtonGroup} from "react-bootstrap";
import {connect} from "react-redux";
import {networkDeviceActions} from "../actions/network-device.actions";
import {modalActions} from "../actions/modal.actions";

const DiagnosticModeButton = ({t, size = "", networkDevice, reloadSimpleModel = false,  showModal, hideModal, setDiagnosticMode}) => {

    const openConfirmModal = (id, val) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: `<p>${t('change-diagnostic-mode-msg')}</p><p><b>${t('close-single-application-msg')}</b></p>`,
            confirmLabel: t('OK'),
            confirmIcon: 'fa-check-circle',
            classNameBtnConfirm: 'btn-info',
            dataId: id,
            confirmAction: (id) => {
                setDiagnosticMode(id, val, reloadSimpleModel);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const closeModal = () => {
        hideModal()
    };

    return (
        <div>
            <span> {t('diagnostic-mode')} </span> &nbsp;
            <ButtonGroup size={size} className="mx-0 my-1">
                <Button variant={ networkDevice.diagnosticMode ? 'outline-danger' : 'outline-secondary'}
                        active={ networkDevice.diagnosticMode }
                        onClick={() => openConfirmModal(networkDevice.id, !networkDevice.diagnosticMode) }>
                    {t('on')}
                </Button>
                <Button variant={'outline-secondary'}
                        active={ !networkDevice.diagnosticMode }
                        onClick={() => openConfirmModal(networkDevice.id, !networkDevice.diagnosticMode) }>
                    {t('off')}
                </Button>
            </ButtonGroup>
        </div>
    )
};

const mapDispatchToProps = dispatch => ({
    setDiagnosticMode: (id, val, reload) => dispatch(networkDeviceActions.setDiagnosticMode(id, val, reload)),
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    }
});


export default withNamespaces()(connect(null, mapDispatchToProps)(DiagnosticModeButton));
